import { selectDepartmentById } from "./departmentsSlice";
import { useAppSelector } from "../../common/hooks/useStore";

interface DepartmentLabelProps {
  value: string;
}

export default function DepartmentLabel({ value }: DepartmentLabelProps) {
  const department = useAppSelector((state) => selectDepartmentById(state, value));

  return <div>{department?.name}</div>;
}
